import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
const LoginPage = lazy(/* webpackChunkName: "login" */() => import(/* webpackChunkName: "login" */"@pages/LoginPage"));

const AuthRoutes: React.FC = () => (
  <Switch>
    <Suspense fallback={<div>Loading...</div>}>
      <Route path="/registrar" component={LoginPage} />
      <Route exact path="/">
        <Redirect to="/registrar" />
      </Route>
      <Route path="/">
        <Redirect to="/registrar" />
      </Route>
      <Route path="*">
        <Redirect to="/registrar" />
      </Route>
    </Suspense>
  </Switch>
);

export default AuthRoutes;
